import React from 'react';
import { AeIconButton } from '@/components/assessment-engine/layout/AeIconButton';

type BuilderIconButtonVariant = 'default' | 'primary' | 'danger';

interface BuilderIconButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: BuilderIconButtonVariant;
  children: React.ReactNode;
}

/** Template builder icon control — delegates to shared AeIconButton. */
export const BuilderIconButton: React.FC<BuilderIconButtonProps> = (props) => (
  <AeIconButton {...props} />
);
